module.exports = __webpack_public_path__ + "assets/img/siding-5.afa7b047.jpg";